import Search from "@insite/mobius/Icons/Search";
import { searchInputStyles } from "@MasterBluePrint/Overrides/Widgets/Header/SearchInput";
import { css } from "styled-components";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { src: Search },
    border: "rounded", // full rectangle border
    cssOverrides: {
        formField: css`
            height: 2.5rem;
            width: 20rem; // longer search box
            margin-top: 0.5rem;
            position: relative;
            @media screen and (max-width:991px) {
                margin-top: 0.3125rem;
            }
            @media (max-width: 767px) {
               // width: 100%; // longer search box
                //min-width:15.625rem;
                margin-left: .31250625rem;
            }
            @media (max-width: 454px) {
               width: 15.625rem;
            }
            @media screen and (max-width: 767px) and (min-width: 576px) {
                //min-width: 22.9375rem;
            }
            @media screen and (max-width: 1023px) and (min-width: 990px) {
                //width: 1.1719rem;
            }
            > div > input {
                        letter-spacing: .01rem;
                        line-height: 1.125rem;
                        color: #424B5A;
                        font-family: Lato;
                        font-size: .875rem;
                        border: 1px solid rgba(32,96,173,0.5);
                        border-radius: 2px !important;
                        background-color: rgba(224, 231, 255, .5) !important;
                        &:focus {
                            border: 2px solid #2060ad;
                            border-radius: .125rem;
                            background-color: #ffffff;
                            padding-right: 1.875rem !important;
                        }
                    }
            } 
        `,
    },
};
